import Vue from 'vue'
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'
import VueScrollTo from 'vue-scrollto'

//TG 10-31-22 - Added so null values formatted w numFormat filter show '-' instead of 0.
numeral.nullFormat('-')

Vue.filter('numFormat', numFormat(numeral))

Vue.use(VueScrollTo)
